import { Moon, Sun } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useTheme } from "../hooks/useTheme";

export default function Header({ onCta }) {
  const [theme, toggleTheme] = useTheme();
  const { pathname } = useLocation();
  const isInvite = pathname.startsWith("/invite");

  return (
    <header className="fixed inset-x-0 top-0 z-40">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3 sm:px-6">
        <a
          href="/"
          data-testid="header-logo"
          className="flex items-center gap-2 rounded-full border border-nora-ink/5 bg-nora-surface/80 px-3 py-1.5 shadow-sm backdrop-blur-xl"
        >
          <img
            src="/logo.png"
            alt="NORA"
            className="h-8 w-8 rounded-full"
          />
          <span className="font-display text-sm font-extrabold tracking-widest">
            NORA
          </span>
        </a>
        <div className="flex items-center gap-2">
          {!isInvite && (
            <Link
              to="/referral"
              data-testid="header-referral-link"
              className="hidden rounded-full border border-nora-ink/5 bg-nora-surface/80 px-4 py-2.5 text-sm font-semibold backdrop-blur-xl transition-colors hover:text-nora-accent sm:block"
            >
              Пригласить друга
            </Link>
          )}
          <button
            type="button"
            data-testid="theme-toggle-button"
            onClick={toggleTheme}
            aria-label="Переключить тему"
            className="rounded-full border border-nora-ink/5 bg-nora-surface/80 p-2.5 shadow-sm backdrop-blur-xl transition-transform hover:scale-105 active:scale-95"
          >
            {theme === "dark" ? (
              <Sun className="h-4 w-4 text-nora-accent" />
            ) : (
              <Moon className="h-4 w-4 text-nora-ink/70" />
            )}
          </button>
          {!isInvite && (
            <button
              type="button"
              data-testid="header-cta-button"
              onClick={onCta}
              className="hidden rounded-full bg-nora-accent px-5 py-2.5 font-display text-xs font-bold text-[#1F2730] shadow-lg shadow-nora-accent/25 transition-colors hover:bg-nora-accenthover md:block"
            >
              Попробовать бесплатно 1 день
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
